import { KeyRound, Info, CheckCircle, AlertTriangle, Clock } from "lucide-react";

export default function PortalAgentTokenSection({
  clientSlug,
  localAgentEnabled = true,
  lastSyncAt,
  lastError,
}) {
  if (!localAgentEnabled) {
    return (
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden max-w-2xl">
        <div className="p-6 border-b border-stone-100 bg-stone-50/50">
          <h2 className="text-xl font-semibold flex items-center gap-2 text-stone-800">
            <KeyRound size={22} className="text-stone-400" /> Agent de
            synchronisation locale (RAGUIA)
          </h2>
        </div>
        <div className="p-6">
          <div className="flex gap-3 rounded-xl border border-blue-100 bg-blue-50/90 p-4 text-sm text-stone-800">
            <Info className="shrink-0 mt-0.5 text-blue-600" size={22} aria-hidden />
            <p className="leading-relaxed">
              L&apos;administrateur Raguia a désactivé l&apos;agent local pour cet espace : il
              n&apos;y a pas de jeton à configurer ni de synchronisation automatique depuis un
              dossier sur les postes. Les documents peuvent toujours être déposés via le portail
              (upload manuel).
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden max-w-2xl">
      <div className="p-6 border-b border-stone-100 bg-stone-50/50">
        <h2 className="text-xl font-semibold flex items-center gap-2 text-stone-800">
          <KeyRound size={22} className="text-amber-600" /> Agent de
          synchronisation locale (RAGUIA)
        </h2>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-sm text-stone-600 leading-relaxed">
          L&apos;agent local se connecte désormais avec les identifiants portail
          (slug + mot de passe), puis récupère automatiquement un jeton agent
          sécurisé en arrière-plan.
        </p>
        {(lastSyncAt || lastError) && (
          <div className={`rounded-xl border p-4 text-sm space-y-2 ${lastError ? "border-amber-200 bg-amber-50/80" : "border-green-200 bg-green-50/80"}`}>
            <p className="font-medium text-stone-900 flex items-center gap-2">
              {lastError ? (
                <AlertTriangle size={16} className="text-amber-600" />
              ) : (
                <CheckCircle size={16} className="text-green-600" />
              )}
              Statut agent
            </p>
            {lastSyncAt && (
              <p className="text-stone-700 flex items-center gap-2">
                <Clock size={14} className="text-stone-400" />
                Dernière synchronisation : {new Date(lastSyncAt).toLocaleString()}
              </p>
            )}
            {lastError && (
              <p className="text-amber-800 break-words">
                {lastError}
              </p>
            )}
          </div>
        )}
        <div className="rounded-xl border border-blue-100 bg-blue-50/80 p-4 text-sm text-stone-700 space-y-2">
          <p className="font-medium text-stone-900">Configuration sur le poste client :</p>
          <p>
            1) Ouvrez l&apos;assistant de l&apos;agent Raguia.
          </p>
          <p>
            2) Saisissez le slug <code>{clientSlug || "client"}</code> et le mot de passe portail.
          </p>
          <p>
            3) L&apos;agent mémorise la session dans le trousseau système et gère le renouvellement automatiquement.
          </p>
        </div>
      </div>
    </div>
  );
}
